import { Logo } from "@app/components/AdminNavbar/components/Logo";
import React from "react";
import ChooseLanguage from "../lang";

interface TitleBarProps {
    logoSrc?: string;
    campaignTitle?: string;
    children: React.ReactNode;
    submitButton: React.ReactNode;
}

const TitleBar = ({
    logoSrc,
    campaignTitle,
    children,
    submitButton,
}: TitleBarProps) => {
    return (
        <div className="flex items-center p-4 pl-[40px] w-screen">
            <div className="w-1/6 flex space-x-[20px] items-center flex-wrap">
                {logoSrc && <img className="max-h-[44px]" src={logoSrc} />}
                <div className=" text-right">
                    <div className="font-bold">{campaignTitle}</div>
                    <div className="space-x-1 flex items-center">
                        <Logo className="h-4" />
                    </div>
                </div>
            </div>
            <div className="relative w-2/3 ">
                <div className="absolute right-0 h-[32px] w-2 bg-gradient-radial from-black/10 to-transparent " />
                <div className="flex justify-left overflow-scroll space-x-3 scrollbar-hide">
                    {children}
                </div>
            </div>
            <div className="w-1/6 flex justify-end space-x-7 items-center">
                <ChooseLanguage />
                {submitButton}
            </div>
        </div>
    );
};

export default TitleBar;
